import Action from './action.svg?sprite'
import AllGames from './all_games.svg?sprite'
import AllSeries from './all_series.svg?sprite'
import AllTags from './all_tags.svg?sprite'
import Arcade from './arcade.svg?sprite'
import Balloons from './balloons.svg?sprite'
import Boys from './boys.svg?sprite'
import Car from './car.svg?sprite'
import Clicker from './clicker.svg?sprite'
import Drawing from './drawing.svg?sprite'
import Funny from './funny.svg?sprite'
import Girls from './girls.svg?sprite'
import Gun from './gun.svg?sprite'
import Horror from './horror.svg?sprite'
import Idle from './idle.svg?sprite'
import Io from './io.svg?sprite'
import Multiplayer from './multiplayer.svg?sprite'
import New from './new.svg?sprite'
import Obby from './obby.svg?sprite'
import Puzzle from './puzzle.svg?sprite'
import Random from './random.svg?sprite'
import Recommended from './recommended.svg?sprite'
import Shooting from './shooting.svg?sprite'
import Simulation from './simulation.svg?sprite'
import Skill from './skill.svg?sprite'
import Snake from './snake.svg?sprite'
import Soccer from './soccer.svg?sprite'
import Solitaire from './solitaire.svg?sprite'
import Sports from './sports.svg?sprite'
import Strategy from './strategy.svg?sprite'
import TopGrowth from './top_growth.svg'
import TopPlaygama from './top_playgama.svg?sprite'
import TrendingNow from './trending_now.svg?sprite'
import TwoPlayer from './two_player.svg?sprite'

export const categoriesIcons = {
    action: Action,
    all_games: AllGames,
    all_series: AllSeries,
    all_tags: AllTags,
    arcade: Arcade,
    boys: Boys,
    'bubble-shooter': Balloons,
    car: Car,
    clicker: Clicker,
    drawing: Drawing,
    funny: Funny,
    girls: Girls,
    gta: Car,
    gun: Gun,
    horror: Horror,
    idle: Idle,
    io: Io,
    multiplayer: Multiplayer,
    new: New,
    puzzle: Puzzle,
    obby: Obby,
    racing: Car,
    random: Random,
    recommended: Recommended,
    shooting: Shooting,
    simulation: Simulation,
    skill: Skill,
    snake: Snake,
    soccer: Soccer,
    solitaire: Solitaire,
    sports: Sports,
    strategy: Strategy,
    trending_now: TrendingNow,
    top_playgama: TopPlaygama,
    'two-player': TwoPlayer,
    top_growth: TopGrowth,
}
